import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconSquareFillComponent } from "./med-icon-square-fill.component";

@NgModule({
  declarations: [
    MedIconSquareFillComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconSquareFillComponent,
  ],
})
export class MedIconSquareFillModule { }
